import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const MinimalLine: React.FC<CoverTemplateProps> = ({
    fields,
    colors,
    logoUrl,
    showLogo,
}) => (
    <div className="flex size-full flex-col gap-[1.2em] px-[2.4em] py-[3em]">
        <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
        <div
            className="h-[3px] w-[3.5em] rounded-[2px]"
            style={{ backgroundColor: colors.secondary }}
        />
        <div
            className="font-bold leading-[1.05] tracking-[-0.02em]"
            style={{ fontSize: coverTitleSize(2) }}
        >
            {fields.document_title}
        </div>
        {fields.subtitle ? (
            <div className="text-[0.82em]" style={{ color: COVER_DIM_ON_LIGHT }}>
                {fields.subtitle}
            </div>
        ) : null}
        <CoverMeta fields={fields} className="mt-auto" />
    </div>
);
